module.exports = __webpack_public_path__ + "static/media/logo.ee7aeaf3.svg";